// extracted by mini-css-extract-plugin
export default {"my-store-marker":"static-map__my-store-marker___9GI4d","marker":"static-map__marker___jhv8P","container":"static-map__container___bw_WW"};